/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignPlatformSchema,
  countResponseSchema,
} from '../campaign-schema';

export const getCampaignCreatorsCountPathSchema = z.object({
  campaignId: z.string(),
});

export const getCampaignCreatorsCountQuerySchema = z.object({
  platform: campaignPlatformSchema.optional(),
  name: z.string().optional(),
  label: z.string().optional(),
});

export const getCampaignCreatorsCountOperationResponseSchema =
  countResponseSchema;

export type GetCampaignCreatorsCountInput = {
  path: z.input<typeof getCampaignCreatorsCountPathSchema>;
  query?: z.input<typeof getCampaignCreatorsCountQuerySchema>;
  signal?: AbortSignal;
};

export async function getCampaignCreatorsCount({
  path,
  query,
  signal,
}: GetCampaignCreatorsCountInput): Promise<
  z.infer<typeof getCampaignCreatorsCountOperationResponseSchema>
> {
  const parsedPath = getCampaignCreatorsCountPathSchema.parse(path);
  const parsedQuery = getCampaignCreatorsCountQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/creators/count`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return getCampaignCreatorsCountOperationResponseSchema.parse(
    await response.json(),
  );
}
